import type { IconSvgObject } from './types';

const CornerRightUpIcon: IconSvgObject = [
  ["path", { d: "M15 5.00195L15 12.002C15 15.7732 15 17.6588 13.8284 18.8304C12.6569 20.002 10.7712 20.002 7 20.002L4 20.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 9.00191C20 9.00191 16.3176 4.00196 15 4.00195C13.6824 4.00194 10 9.00195 10 9.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerRightUpIcon;
